import React from "react";
import translate, {getTranslator} from "../../translate";
import {TranslationContext} from "./TranslationContext";

export function TranslationProvider({ children }) {
    function changeLanguage(newLanguage: string) {
        return Promise.resolve();
    }

    return <TranslationContext.Provider value={{
        language: 'en',
        setLanguage: changeLanguage,
        translate,
        getTranslator,
    }}>
        {children}
    </TranslationContext.Provider>
}
